<template>
    <div
        id="landing-activation"
        class="bg-light"
    >
        <div class="body-wrapper">
            <header
                role="navigation"
                class="navbar navbar-expand-md navbar-light shadow px-3 px-md-5"
            >
                <b-navbar-toggle
                    target="nav-collapse"
                    class="navbar-toggler border-0 p-0"
                />

                <span class="navbar-brand mr-0 mr-md-3 p-0 d-inline-flex align-items-center">
                    <img
                        v-if="logoUrl"
                        :src="logoUrl"
                        alt="RikordaEventi"
                        class="mw-100 mh-100"
                    >
                </span>

                <span class="navbar-toggler border-0 p-0"></span>

                <b-navbar
                    toggleable="md"
                    id="navbarSupportedContent"
                    class="navbar-collapse p-0 d-md-flex bg-transparent"
                >
                    <b-collapse
                        id="nav-collapse"
                        is-nav
                        class="navbar-nav pt-3 pt-md-0 align-items-center text-uppercase"
                    >
                        <router-link
                            :to="{ name: 'page-howitworks' }"
                            class="nav-item nav-link mr-md-3"
                        >
                            <font-awesome-icon :icon="['fas', 'question-circle']" />
                            &nbsp;{{ $t("Come funziona") }}
                        </router-link>
                        <router-link
                            :to="{ name: 'page-contacts' }"
                            v-if="!isGlobalSite"
                            class="nav-item nav-link ml-md-3"
                        >
                            <font-awesome-icon :icon="['fas', 'comments']" />
                            &nbsp;{{ $t("Contatti") }}
                        </router-link>
                    </b-collapse>
                </b-navbar>
            </header>
            <main class="d-flex justify-content-center align-items-center flex-wrap mx-auto py-4 px-2">
                <ValidationObserver
                    v-slot="{handleSubmit}"
                    v-if="showRegisterForm"
                >
                    <h1>{{$t('Registrazione')}}</h1>
                    <form
                        ref="registration-form"
                        id="registration-form"
                    >
                        <fieldset>
                            <div class="form-row">
                                <div class="col-12 col-sm form-group">
                                    <label for="email">{{ $t("Email") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required|email|confirmed:checkMail"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="email"
                                            name="email"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="email"
                                            v-model="user.mail"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="col-12 col-sm form-group">
                                    <label for="ripeti-email">{{ $t("Ripeti email") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required|email"
                                        v-slot="{ errors }"
                                        vid="checkMail"
                                    >
                                        <input
                                            type="email"
                                            name="ripeti-email"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="ripeti-email"
                                            v-model="checkEmail"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-12 col-sm form-group">
                                    <label for="password">{{ $t("Password") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required|confirmed:checkPassword"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="password"
                                            name="password"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="password"
                                            v-model="password"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="col-12 col-sm form-group">
                                    <label for="ripeti-password">{{ $t("Ripeti password") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                        vid="checkPassword"
                                    >
                                        <input
                                            type="password"
                                            name="ripeti-password"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="ripeti-password"
                                            v-model="checkPassword"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="mt-3">
                            <!--h5 class="text-uppercase">{{ $t("Indirizzo di spedizione") }}</h5-->
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <label for="nome">{{ $t("Nome") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="nome"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="nome"
                                            required
                                            v-model="user.nome"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <label for="cognome">{{ $t("Cognome") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            type="text"
                                            name="cognome"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            id="cognome"
                                            required
                                            v-model="user.cognome"
                                        />
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <label for="paese">{{ $t("Paese") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <select
                                            name="paese"
                                            id="paese"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            @change="onChangeCountry"
                                            v-model="user.nazione"
                                        >
                                            <option
                                                v-for="country in countryList"
                                                :key="country.id"
                                                :value="country.id"
                                            >{{country.name}}
                                            </option>
                                        </select>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <label for="province">{{$t('Provincia')}} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <select
                                            name="province"
                                            id="province"
                                            ref="province"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            @change="onChangeProvince"
                                            v-model="user.provincia"
                                        >
                                            <option value="">{{$t('Seleziona provincia')}}</option>
                                            <option
                                                v-for="province in provincesList"
                                                v-bind:key="province.Sigla"
                                                v-bind:value="province.Sigla"
                                            >
                                                {{province.Provincia}}
                                            </option>
                                        </select>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="form-row">
                                <div class="col-sm-6 mb-3">
                                    <label for="city">{{ $t("Città") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <select
                                            name="city"
                                            id="city"
                                            ref="city"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            @change="onChangeCity"
                                            v-model="user.citta"
                                        >
                                            <option value="">{{$t('Seleziona città')}}</option>
                                            <option
                                                v-for="(key, value) in citiesList"
                                                v-bind:key="value"
                                                v-bind:value="value"
                                            >
                                                {{value}}
                                            </option>
                                        </select>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                                <div class="col-sm-6 mb-3">
                                    <label for="zip">{{ $t("CAP") }} <span class="text-danger">*</span></label>
                                    <validation-provider
                                        rules="required"
                                        v-slot="{ errors }"
                                    >
                                        <select
                                            name="zip"
                                            id="zip"
                                            ref="zip"
                                            class="form-control rounded-pill rilievo-ombra-interna"
                                            v-model="user.cap"
                                        >
                                            <option value="">{{$t('Seleziona cap')}}</option>
                                            <option
                                                v-for="zip in zipList"
                                                v-bind:key="zip.cap"
                                                v-bind:value="zip.cap"
                                            >
                                                {{zip.cap}}
                                            </option>
                                        </select>
                                        <span class="text-danger">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="indirizzo">{{ $t("Indirizzo") }} <span class="text-danger">*</span></label>
                                <validation-provider
                                    rules="required"
                                    v-slot="{ errors }"
                                >
                                    <input
                                        type="text"
                                        name="indirizzo"
                                        class="form-control rounded-pill rilievo-ombra-interna"
                                        id="indirizzo"
                                        required
                                        v-model="user.indirizzo"
                                    />
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                            </div>
                            <div class="form-group">
                                <label for="telefono">{{ $t("Telefono") }}</label>
                                <validation-provider
                                    rules=""
                                    v-slot="{ errors }"
                                >
                                    <input
                                        type="telephone"
                                        name="telefono"
                                        class="form-control rounded-pill rilievo-ombra-interna"
                                        id="telefono"
                                        v-model="user.telefono"
                                    />
                                    <span class="text-danger">{{errors[0]}}</span>
                                </validation-provider>
                            </div>
                        </fieldset>
                        <fieldset class="mt-3">
                            <label for="flag-termini">
                                {{ $t("Consenso al trattamento dati personali in conformità a quanto previsto dall'") }}
                                <a
                                    href="#"
                                    @click.prevent="onShowPrivacy()"
                                >
                                    {{ $t("informativa sulla privacy") }}
                                </a>
                                {{ $t("ed accettazione delle") }}
                                <a @click.prevent="onShowTerms()">
                                    {{ $t('condizioni del servizio ed i termini e le condizioni') }}
                                </a>
                                {{ $t("di vendita.") }}
                            </label>
                            <div class="border rounded p-2">
                                <div class="form-check">
                                    <validation-provider
                                        :rules="{ required: { allowFalse: false } }"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-bind:value="flagTerms"
                                            v-bind:checked="flagTerms"
                                            id="flag-termini"
                                            @click="setConsent('terms')"
                                        />
                                        {{ $t("Ho letto e autorizzo Rikorda.") }} <span class="text-danger">*</span>

                                        <span class="text-danger d-block">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                        </fieldset>
                        <fieldset class="mt-3">
                            <label for="flag-marketing">
                                {{ $t("Consenso al") }}
                                <a
                                    href="#"
                                    @click.prevent="onShowPrivacy()"
                                >
                                    {{ $t('trattamento dei dati personali') }}
                                </a>
                                {{ $t("ai fini promozionali del servizio stesso.") }}
                            </label>
                            <div class="border rounded p-2">
                                <div class="form-check">
                                    <validation-provider
                                        :rules="{ required: { allowFalse: false } }"
                                        v-slot="{ errors }"
                                    >
                                        <input
                                            class="form-check-input"
                                            type="checkbox"
                                            v-bind:value="flagMarketing"
                                            v-bind:checked="flagMarketing"
                                            id="flag-marketing"
                                            @click="setConsent('marketing')"
                                        />
                                        {{ $t("Ho letto e autorizzo Rikorda.") }} <span class="text-danger">*</span>

                                        <span class="text-danger d-block">{{errors[0]}}</span>
                                    </validation-provider>
                                </div>
                            </div>
                        </fieldset>
                        <div class="text-md-right">
                            <a
                                role="button"
                                class="btn btn-primary btn-rikorda1 mt-3 mb-0 d-block d-md-inline-block mx-auto mx-md-0"
                                @click.prevent="handleSubmit(signUp)"
                            >{{ $t('Avanti') }}</a>
                        </div>
                    </form>
                </ValidationObserver>
                <div
                    class="bg-white rounded p-3 w-100"
                    v-if="!showRegisterForm"
                >
                    <p class="mt-0 mb-0 text-center">
                        <img
                            src="/images/logo.png"
                            alt="Rikorda Eventi"
                            class="mw-30 mh-30"
                        >
                    </p>
                    <p class="mt-3 mb-3 text-center font-weight-bold">{{ activationMessage }}</p>
                    <div class="mb-0 mt-3 text-center">
                        <button
                            class="pulsante-login btn btn-primary btn-rikorda1"
                            @click.prevent="gotoHome"
                        >
                            {{ $t("Vai alla home") }}
                        </button>
                    </div>
                </div>
            </main>

            <gallery-footer ref="footer" />
        </div>
    </div>
</template>

<script>
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required, email, confirmed } from "vee-validate/dist/rules";
import GalleryFooter from "../components/gallery/Footer";

export default {
    name: "LandingActivationAccount",
    components: { ValidationProvider, ValidationObserver, GalleryFooter },
    data() {
        return {
            showRegisterForm: false,
            activationMessage: "",
            countryList: [
                { id: null, name: "Seleziona nazione" },
                { id: "Italia", name: "Italia" }
            ],
            provincesList: [],
            citiesList: {},
            zipList: [],
            flagTerms: false,
            flagMarketing: false,
            user: {},
            checkEmail: "",
            password: "",
            checkPassword: ""
        };
    },

    mounted() {
        let activationKey = this.$route.params.activationKey;
        this.$api
            .activateAccount(activationKey)
            .then((result) => {
                console.debug("ACTIVATE_ACCOUNT", result);
                if (result.status === "success") {
                    this.activationMessage = "Account attivato con successo";
                    if (
                        Object.prototype.hasOwnProperty.call(
                            result,
                            "activation"
                        ) &&
                        result["activation"] === "alreadyActive"
                    ) {
                        this.activationMessage =
                            "Attivazione effettuata con successo";
                    }
                    if (
                        Object.prototype.hasOwnProperty.call(result, "user") &&
                        result.user &&
                        result.user["username"]
                    ) {
                        this.activationMessage = "";
                        this.user = result.user;
                        var storedShopData = this.$store.getters.shopData;
                        storedShopData["shop"] = result.shop;
                        storedShopData["docs"] = result.docs;
                        this.$store.commit("UPDATE_SHOP_DATA", storedShopData);
                        this.showRegisterForm = true;
                        this.$nextTick(() => {
                            this.onChangeCountry();
                        });
                        extend("required", {
                            ...required,
                            message: this.$t("Campo obbligatorio")
                        });
                        extend("email", {
                            ...email,
                            message: this.$t("Inserire una e-mail valida")
                        });
                        extend("confirmed", {
                            ...confirmed,
                            message: this.$t("I campi devono coincidere")
                        });
                    }
                }
            })
            .catch((error) => {
                console.error("ACTIVATE_ACCOUNT", error);
                this.activationMessage = "Chiave di attivazione non valida";
            });
    },

    computed: {
        logoUrl() {
            let shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.logoUrl ? shopData.logoUrl : "";
        },
        isGlobalSite() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.isGlobalSite;
        }
    },

    methods: {
        gotoHome() {
            this.$router.push({ name: "home" });
        },
        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },
        onChangeCountry() {
            this.$refs.province.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.zip.disabled = true;
            this.$api
                .getItalyProvinces()
                .then((result) => {
                    console.debug("GET_ITALY_PROVINCES", result);
                    this.provincesList = result.provinces;
                    this.$refs.province.disabled = false;
                    this.$refs.city.disabled = false;
                    this.$refs.zip.disabled = false;
                    this.user.nazione = "Italia";
                })
                .catch((error) => {
                    console.error("GET_ITALY_PROVINCES", error);
                    alert("Si è verificato un errore. Riprovare più tardi.");
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },
        onChangeProvince() {
            this.$refs.province.disabled = true;
            this.$refs.city.disabled = true;
            this.$refs.zip.disabled = true;
            this.$api
                .getItalyCities(this.$refs.province.value)
                .then((result) => {
                    console.debug("GET_ITALY_CITIES", result);
                    this.citiesList = result.cities;
                    this.$refs.province.disabled = false;
                    this.$refs.city.disabled = false;
                    this.$refs.zip.disabled = false;
                })
                .catch((error) => {
                    console.error("GET_ITALY_CITIES", error);
                    this.$router.push({
                        name: this.$route.meta.gotoOnAuthFailed,
                        params: this.$route.params
                    });
                });
        },
        onChangeCity() {
            if (this.citiesList[this.$refs.city.value]) {
                this.zipList = this.citiesList[this.$refs.city.value];
                if (
                    this.zipList.filter((zip) => {
                        return zip.cap === this.$refs.zip.value;
                    }).length === 0
                ) {
                    this.$refs.zip.value = "";
                }
            } else {
                this.zipList = [];
                this.$refs.zip.value = "";
            }
        },
        setConsent(consentType) {
            if (consentType === "terms") {
                this.flagTerms = !this.flagTerms;
            }
            if (consentType === "marketing") {
                this.flagMarketing = !this.flagMarketing;
            }
        },
        signUp() {
            let params = {
                Mail: this.user.mail,
                Nome: this.user.nome,
                Cognome: this.user.cognome,
                Ragionesociale: this.user.cognome + " " + this.user.nome,
                Indirizzo: this.user.indirizzo,
                Cap: this.user.cap,
                Citta: this.user.citta,
                Provincia: this.user.provincia,
                Nazione: this.user.nazione,
                Tel: this.user.tel ? this.user.tel : "",
                Tipocaricamento: this.user.tipoCaricamento,
                Privacy3: this.user.privacy3,
                Flagfattura: this.user.flagFattura,
                Consegna: this.user.consegna,
                Password: this.password
            };
            this.$api
                .completeAgentProfile(this.user.idUtente, params)
                .then((result) => {
                    console.debug("COMPLETE_AGENT_PROFILE", result);
                    if (result.status === "success") {
                        this.activationMessage =
                            "Account attivato con successo";
                        this.showRegisterForm = false;
                    }
                })
                .catch((error) => {
                    console.error("COMPLETE_AGENT_PROFILE", error);
                });
        },
        onShowTerms() {
            this.$refs.footer.onShowTerms();
        },
        onShowPrivacy() {
            this.$refs.footer.onShowPrivacy();
        }
    }
};
</script>

<style scoped>
</style>
